import { highLevelLegacyPages } from 'Src/helpers/tournament/highLevelNavigation';
import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { HighLevelTournamentsUpcoming } from './HighLevelTournamentsUpcoming/HighLevelTournamentsUpcoming';
import { HighLevelTournamentsArchive } from './HighLevelTournamentsArchive/HighLevelTournamentsArchive';
import {TournamentParticipation} from '../../TournamentParticipation/TournamentParticipation';
import { HighLevelTournamentsListHeader } from './HighLevelTournamentsListHeader';
import { SchoolTournamentCommunicationsInbox } from '../../AdminView/Tournaments/SchoolTournamentCommunicationsInbox';

export const HighLevelTournamentsRouting = allProps => {
  return (
    <Switch>
      {Object.keys(highLevelLegacyPages).map(path => <Route key={path} exact path={`/highLevelTournaments/${path}`} render={props => <Redirect to={{pathname: `/highLevelTournaments/participation/${highLevelLegacyPages[path]}`, search: props.location.search, state: props.location.state}} />} />)}
      <Route exact path="/highLevelTournaments/communications" render={props => <div className="hltHighLevelInbox"><HighLevelTournamentsListHeader {...props} user={allProps.user} activeSection="communications" /><SchoolTournamentCommunicationsInbox {...props} user={allProps.user} highLevel /></div>} />
      <Route exact path="/highLevelTournaments/participation/:section?/:detail?" render={props => <TournamentParticipation {...props} user={allProps.user} union />} />
      <Route
        exact
        key="upcoming"
        path={'/highLevelTournaments/upcoming'}
        render={props => <HighLevelTournamentsUpcoming {...props} user={allProps.user} />}
      />
      <Route
        exact
        key="archive"
        path={'/highLevelTournaments/archive'}
        render={props => <HighLevelTournamentsArchive {...props} user={allProps.user} />}
      />
    </Switch>
  );
};

HighLevelTournamentsRouting.displayName = 'HighLevelTournamentsRouting';
